// extracted by mini-css-extract-plugin
module.exports = {"card_grey_banner":"GreyBanner_card_grey_banner__3HqKO","small":"GreyBanner_small__36h2e","text_md_right":"GreyBanner_text_md_right__24196"};